import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ModuleFlow, handleError } from '../../../../shared/utils/error.utils';
import { buildHttpParams } from '../../../../shared/utils/http.utils';
import { RoleRepository } from '../../domain/repository';
import { ApiResponse } from '../../../../shared/dto/response/api-response.dto';
import { getApiBaseUrl } from '../../../../shared/config/runtime-config';
import {
  RoleFindRequest,
  RoleFindResponse,
  RoleFindAllRequest,
  RoleFindAllResponse,
} from '../../domain/dto';

@Injectable({ providedIn: 'root' })
export class RoleRepositoryImpl implements RoleRepository {
  constructor(private http: HttpClient) {}

  findAllPath(): string {
    return this.apiUrl;
  }

  findAll(payload: RoleFindAllRequest = {}): Observable<HttpResponse<RoleFindAllResponse>> {
    const params = buildHttpParams(payload);

    return this.http
      .get<ApiResponse<RoleFindAllResponse>>(this.findAllPath(), {
        observe: 'response',
        params,
      })
      .pipe(
        map((response) => response.clone({ body: response.body?.data ?? [] })),
        catchError((error) => handleError(ModuleFlow.RoleFindAll, error)),
      );
  }

  find(payload: RoleFindRequest): Observable<HttpResponse<RoleFindResponse>> {
    return this.http
      .get<
        ApiResponse<RoleFindResponse>
      >(`${this.apiUrl}/${payload.id}`, { observe: 'response' })
      .pipe(
        map((response) => response.clone({ body: response.body?.data })),
        catchError((error) => handleError(ModuleFlow.RoleFind, error)),
      );
  }

  private get apiUrl(): string {
    return getApiBaseUrl('catalogs/roles');
  }
}


